import { useContext } from "react";
import { AuthContext } from "./authContext";

export const usePermission = () => {
  const c = useContext(AuthContext);

  return [c.hasPermission];
};
